import { render, staticRenderFns } from "./Gutschein.vue?vue&type=template&id=52bee331"
import script from "./Gutschein.vue?vue&type=script&lang=js"
export * from "./Gutschein.vue?vue&type=script&lang=js"
import style0 from "./Gutschein.vue?vue&type=style&index=0&id=52bee331&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports